export const categories = [
  {
    id: "shoes",
    name: "Tênis",
    nameEn: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image: "https://readdy.ai/api/search-image?query=White%20minimalist%20running%20sneaker%20floating%20on%20warm%20beige%20studio%20backdrop%2C%20dynamic%20angle%20product%20photography%2C%20clean%20athletic%20silhouette%2C%20soft%20directional%20lighting%2C%20editorial%20fashion%20quality%2C%20no%20text%20no%20watermark&width=600&height=600&seq=cat-sneaker-v2&orientation=squarish"
  },
  {
    id: "hoodies",
    name: "Moletons",
    nameEn: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    image: "https://readdy.ai/api/search-image?query=Oversized%20grey%20hoodie%20folded%20neatly%20on%20light%20sand%20colored%20surface%2C%20top%20down%20flat%20lay%2C%20textured%20fabric%20details%20visible%2C%20natural%20window%20light%2C%20minimalist%20catalog%20aesthetic%2C%20no%20text%20no%20watermark&width=600&height=600&seq=cat-hoodie-v2&orientation=squarish"
  },
  {
    id: "tshirts",
    name: "Camisetas",
    nameEn: "T-Shirts",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20white%20cotton%20t-shirt%20hanging%20on%20wooden%20hanger%20against%20warm%20oatmeal%20wall%2C%20side%20profile%20view%2C%20soft%20fabric%20drape%2C%20clean%20studio%20lighting%2C%20editorial%20fashion%20catalog%2C%20no%20text%20no%20watermark&width=600&height=600&seq=cat-tshirt-v2&orientation=squarish"
  },
  {
    id: "jackets",
    name: "Jaquetas",
    nameEn: "Jackets",
    url: "https://kaspreadsheet.com/category-914-Jackets.html",
    image: "https://readdy.ai/api/search-image?query=Stylish%20bomber%20jacket%20draped%20artistically%20on%20warm%20taupe%20backdrop%2C%20three%20quarter%20angle%20product%20photography%2C%20visible%20texture%20and%20stitching%2C%20soft%20dramatic%20lighting%2C%20editorial%20quality%2C%20no%20text%20no%20watermark&width=600&height=600&seq=cat-jacket-v2&orientation=squarish"
  },
  {
    id: "pants",
    name: "Calças/Shorts",
    nameEn: "Pants/Shorts",
    url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    image: "https://readdy.ai/api/search-image?query=Casual%20beige%20chino%20pants%20laid%20flat%20on%20warm%20terracotta%20toned%20surface%2C%20bird%20eye%20view%2C%20crisp%20folds%20and%20details%2C%20soft%20natural%20daylight%2C%20minimalist%20catalog%20style%2C%20no%20text%20no%20watermark&width=600&height=600&seq=cat-pants-v2&orientation=squarish"
  },
  {
    id: "headwear",
    name: "Chapéus/Bonés",
    nameEn: "Headwear",
    url: "https://kaspreadsheet.com/category-916-Headwear.html",
    image: "https://readdy.ai/api/search-image?query=Classic%20baseball%20cap%20sitting%20on%20warm%20stone%20colored%20pedestal%2C%20slight%20angle%20showing%20brim%20curve%2C%20clean%20studio%20product%20photography%2C%20soft%20key%20light%2C%20editorial%20fashion%20quality%2C%20no%20text%20no%20watermark&width=600&height=600&seq=cat-cap-v2&orientation=squarish"
  },
  {
    id: "sets",
    name: "Conjuntos",
    nameEn: "Sets",
    url: "https://kaspreadsheet.com/category-917-Sets.html",
    image: "https://readdy.ai/api/search-image?query=Coordinated%20two%20piece%20outfit%20set%20displayed%20on%20warm%20blush%20pink%20background%2C%20flat%20lay%20arrangement%2C%20matching%20top%20and%20bottom%2C%20soft%20romantic%20lighting%2C%20editorial%20catalog%2C%20no%20text%20no%20watermark&width=600&height=600&seq=cat-sets-v2&orientation=squarish"
  },
  {
    id: "underwear",
    name: "Roupa Íntima",
    nameEn: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html",
    image: "https://readdy.ai/api/search-image?query=Soft%20cotton%20boxer%20briefs%20folded%20elegantly%20on%20warm%20linen%20textured%20surface%2C%20close%20up%20detail%20shot%2C%20gentle%20fabric%20texture%2C%20soft%20diffused%20lighting%2C%20minimalist%20product%20photography%2C%20no%20text%20no%20watermark&width=600&height=600&seq=cat-under-v2&orientation=squarish"
  },
  {
    id: "jersey",
    name: "Camisas de Time",
    nameEn: "Jersey",
    url: "https://kaspreadsheet.com/category-919-Jersey.html",
    image: "https://readdy.ai/api/search-image?query=Sports%20team%20jersey%20displayed%20flat%20on%20warm%20olive%20green%20background%2C%20top%20down%20view%2C%20breathable%20mesh%20fabric%20visible%2C%20clean%20stadium%20inspired%20lighting%2C%20editorial%20sports%20catalog%2C%20no%20text%20no%20watermark&width=600&height=600&seq=cat-jersey-v2&orientation=squarish"
  },
  {
    id: "accessories",
    name: "Acessórios",
    nameEn: "Accessories",
    url: "https://kaspreadsheet.com/category-920-Accessories.html",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20silver%20watch%20and%20bracelet%20arranged%20on%20warm%20sand%20colored%20suede%20surface%2C%20elegant%20lifestyle%20product%20photography%2C%20soft%20reflections%2C%20luxury%20editorial%20quality%2C%20no%20text%20no%20watermark&width=600&height=600&seq=cat-acc-v2&orientation=squarish"
  },
  {
    id: "bags",
    name: "Bolsas",
    nameEn: "Bags",
    url: "https://kaspreadsheet.com/category-921-Bags.html",
    image: "https://readdy.ai/api/search-image?query=Elegant%20leather%20crossbody%20bag%20standing%20upright%20on%20warm%20cognac%20colored%20surface%2C%20slight%20angle%20showing%20strap%20detail%2C%20rich%20texture%2C%20golden%20hour%20lighting%2C%20editorial%20fashion%20quality%2C%20no%20text%20no%20watermark&width=600&height=600&seq=cat-bags-v2&orientation=squarish"
  },
  {
    id: "belts",
    name: "Cintos",
    nameEn: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Bags.html",
    image: "https://readdy.ai/api/search-image?query=Genuine%20leather%20belt%20coiled%20elegantly%20on%20warm%20espresso%20colored%20wooden%20surface%2C%20brass%20buckle%20detail%2C%20close%20up%20product%20photography%2C%20rich%20texture%20lighting%2C%20editorial%20quality%2C%20no%20text%20no%20watermark&width=600&height=600&seq=cat-belt-v2&orientation=squarish"
  },
  {
    id: "perfumes",
    name: "Perfumes",
    nameEn: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Bags.html",
    image: "https://readdy.ai/api/search-image?query=Crystal%20glass%20perfume%20bottle%20with%20golden%20liquid%20on%20warm%20champagne%20colored%20silk%2C%20dramatic%20side%20lighting%2C%20luxury%20fragrance%20product%20photography%2C%20elegant%20reflections%2C%20editorial%20quality%2C%20no%20text%20no%20watermark&width=600&height=600&seq=cat-perf-v2&orientation=squarish"
  },
  {
    id: "other",
    name: "Outros",
    nameEn: "OtherStuff",
    url: "https://kaspreadsheet.com/search-924/name/Bags.html",
    image: "https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20gadgets%20and%20accessories%20artistically%20arranged%20on%20warm%20putty%20colored%20surface%2C%20flat%20lay%20composition%2C%20varied%20textures%2C%20soft%20overhead%20lighting%2C%20editorial%20catalog%2C%20no%20text%20no%20watermark&width=600&height=600&seq=cat-other-v2&orientation=squarish"
  }
];

export const featuredProducts = [
  {
    id: "fp-1",
    name: "Tênis Runner Premium",
    price: "¥168",
    category: "Tênis",
    image: "https://readdy.ai/api/search-image?query=Premium%20athletic%20running%20shoe%20in%20motion%20pose%20on%20warm%20terracotta%20gradient%20backdrop%2C%20dynamic%20product%20photography%2C%20mesh%20and%20foam%20details%2C%20sporty%20editorial%20lighting%2C%20energy%20and%20speed%20vibe%2C%20no%20text%20no%20watermark&width=500&height=500&seq=fp-runner-v2&orientation=squarish"
  },
  {
    id: "fp-2",
    name: "Moletom Essential",
    price: "¥129",
    category: "Moletons",
    image: "https://readdy.ai/api/search-image?query=Cozy%20heathered%20pullover%20hoodie%20on%20warm%20mocha%20colored%20backdrop%2C%20front%20view%20flat%20lay%2C%20soft%20fleece%20interior%20peeking%2C%20comfort%20lifestyle%20photography%2C%20warm%20autumn%20tones%2C%20no%20text%20no%20watermark&width=500&height=500&seq=fp-hoodie-v2&orientation=squarish"
  },
  {
    id: "fp-3",
    name: "Bolsa Casual Clássica",
    price: "¥89",
    category: "Bolsas",
    image: "https://readdy.ai/api/search-image?query=Canvas%20tote%20bag%20leaning%20casually%20against%20warm%20honey%20colored%20wall%2C%20natural%20material%20texture%2C%20everyday%20carry%20lifestyle%20shot%2C%20soft%20morning%20light%2C%20editorial%20quality%2C%20no%20text%20no%20watermark&width=500&height=500&seq=fp-bag-v2&orientation=squarish"
  },
  {
    id: "fp-4",
    name: "Camiseta Algodão Puro",
    price: "¥45",
    category: "Camisetas",
    image: "https://readdy.ai/api/search-image?query=Premium%20organic%20cotton%20tee%20draped%20over%20warm%20sand%20colored%20linen%2C%20wrinkled%20texture%20contrast%2C%20airy%20summer%20vibe%20product%20photography%2C%20soft%20breeze%20movement%2C%20no%20text%20no%20watermark&width=500&height=500&seq=fp-tee-v2&orientation=squarish"
  }
];